import { useState, useEffect, useRef } from "react";
import StudentMobileLeftside from "./StudentMobileLeftside";
import { Link, useNavigate, useLocation } from "react-router-dom";
import API_BASE_URL from "../config/api";

function Studentheader() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [isAccountOpen, setIsAccountOpen] = useState(false);

   const [open, setOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const accountRef = useRef(null);

  /* ---------------- Normalize User ---------------- */
  const normalizeUser = (u) => {
    if (!u) return null;
    return {
      id: u.id ?? u.userid ?? u.userId ?? null,
      name: u.name ?? u.fullname ?? u.username ?? "User",
      picture_url:
        u.picture_url ??
        (u.profile_pic
          ? String(u.profile_pic).startsWith("http")
            ? u.profile_pic
            : `${API_BASE_URL}/${String(u.profile_pic).replace(/^\/+/, "")}`
          : ""),
    };
  };

  /* ---------------- Load User ---------------- */
  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("user");
      if (raw) {
        setUser(normalizeUser(JSON.parse(raw)));
        setIsLoggedIn(true);
      }
    } catch {
      setUser(null);
      setIsLoggedIn(false);
    }

    const onUserUpdated = (e) => {
      if (e?.detail) {
        sessionStorage.setItem("user", JSON.stringify(e.detail));
        setUser(normalizeUser(e.detail));
        setIsLoggedIn(true);
      }
    };

    window.addEventListener("userUpdated", onUserUpdated);
    return () => window.removeEventListener("userUpdated", onUserUpdated);
  }, []);

  /* ---------------- Close on Route Change ---------------- */
  useEffect(() => {
    setIsAccountOpen(false);
  }, [location.pathname]);

  /* ---------------- Click Outside Close ---------------- */
  useEffect(() => {
    const handler = (e) => {
      if (accountRef.current && !accountRef.current.contains(e.target)) {
        setIsAccountOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  /* ---------------- Logout ---------------- */
  const handleLogout = () => {
    sessionStorage.removeItem("user");
    setUser(null);
    setIsLoggedIn(false);
    navigate("/login");
  };

  const profileImage =
    user?.picture_url?.trim()
      ? user.picture_url
      : `${process.env.PUBLIC_URL}/assets/img/profile.png`;

      const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
      
        useEffect(() => {
          const handleResize = () => {
            setIsMobile(window.innerWidth <= 991);
          };
      
          window.addEventListener("resize", handleResize);
      
          return () => window.removeEventListener("resize", handleResize);
        }, []);
  return (
    <>
     {isMobile && <StudentMobileLeftside />}
     {!isMobile &&
     
      <div className="header header-light head-fixed change-logo">
        <div className="container">
          <nav id="navigation" className="navigation navigation-landscape">
            {/* ---------------- Logo ---------------- */}
            <div className="nav-header">
              <Link className="nav-brand static-logo" to="/">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/img/the-pilot-guide-logo.png`}
                  className="logo"
                  alt="Pilot Guide"
                />
              </Link>
               <Link className="nav-brand fixed-logo" to="#">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/img/the-pilot-guide-logo.png`}
                  className="logo"
                  alt="Pilot Guide"
                />
              </Link>

             <div className="mobile_nav dhsbrd">
                <ul>
                  {!isLoggedIn && (
                    <li className="list-buttons">
                      <Link to="/login" onClick={() => setOpen(false)}>
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path opacity="0.3" d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM12 7C10.3 7 9 8.3 9 10C9 11.7 10.3 13 12 13C13.7 13 15 11.7 15 10C15 8.3 13.7 7 12 7Z" className="fill-main"/>
												<path d="M12 22C14.6 22 17 21 18.7 19.4C17.9 16.9 15.2 15 12 15C8.8 15 6.09999 16.9 5.29999 19.4C6.99999 21 9.4 22 12 22Z" className="fill-main"/>
											</svg>
                      </Link>
                    </li>
                  )}
                  {isLoggedIn && (
                  <li ref={accountRef}>
                    <div className="btn-group account-drop">
                      <button
                        className="btn d-flex align-items-center gap-2"
                        onClick={() => setIsAccountOpen((p) => !p)}
                      >
                        <span className="fw-bold">Hi, {user?.name}</span>
                    <div
  style={{
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    overflow: "hidden",
    background: "#fff",
    border: "2px solid #f58220",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    color: "#1e4f8a",
    fontSize: "14px",
    textTransform: "uppercase",
  }}
>

  {user?.picture_url?.trim() ? (

    <img
      src={profileImage}
      alt="User"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
      onError={(e) => {
        e.currentTarget.style.display = "none";
      }}
    />

  ) : (

    user?.name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .substring(0, 2)

  )}

</div>
                      </button>

                      {/* ---------------- Dropdown ---------------- */}
                      <div
                        className={
                          "dropdown-menu pull-right animated flipInX" +
                          (isAccountOpen ? " show" : "")
                        }
                      >
                        <div className="drp_menu_headr bg-main d-flex justify-content-between align-items-center px-3 py-2">
                          <h4 className="mb-0 text-white">Hi, {user?.name}</h4>
                          <button
                            className="btn btn-whites btn-sm"
                            onClick={handleLogout}
                          >
                            Logout
                          </button>
                        </div>

                        <ul className="px-2 py-1">
                          <li>
                            <Link to="/studentdashboard">
                              <i className="fa fa-tachometer-alt me-2"></i>
                              Dashboard
                            </Link>
                          </li>
                          <li>
                            <Link to="/profile">
                              <i className="fa fa-user-tie me-2"></i>
                              My Profile
                            </Link>
                          </li>
                          {/*<li>
                            <Link to="/enrollments">
                              <i className="fa fa-bookmark me-2"></i>
                              Enrollments
                            </Link>
                          </li>*/}
                          <li>
                            <Link to="/profile/password-change">
                              <i className="fa fa-unlock-alt me-2"></i>
                              Change Password
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  )}
                </ul>
              </div>
            </div>

            {/* ---------------- Right Menu ---------------- */}
            <div className="nav-menus-wrapper">
              <ul className="nav-menu nav-menu-social align-to-right">
                {isLoggedIn && (
                  <li ref={accountRef}>
                    <div className="btn-group account-drop">
                      <button
                        className="btn d-flex align-items-center gap-2"
                        onClick={() => setIsAccountOpen((p) => !p)}
                      >
                        <span className="fw-bold">Hi, {user?.name}</span>
                        <div
  style={{
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    overflow: "hidden",
    background: "#fff",
    border: "2px solid #f58220",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    color: "#1e4f8a",
    fontSize: "14px",
    textTransform: "uppercase",
  }}
>

  {user?.picture_url?.trim() ? (

    <img
      src={profileImage}
      alt="User"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
      onError={(e) => {
        e.currentTarget.style.display = "none";
      }}
    />

  ) : (

    user?.name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .substring(0, 2)

  )}

</div>
                      </button>

                      {/* ---------------- Dropdown ---------------- */}
                      <div
                        className={
                          "dropdown-menu pull-right animated flipInX" +
                          (isAccountOpen ? " show" : "")
                        }
                      >
                        <div className="drp_menu_headr bg-main d-flex justify-content-between align-items-center px-3 py-2">
                          <h4 className="mb-0 text-white">Hi, {user?.name}</h4>
                          <button
                            className="btn btn-whites btn-sm"
                            onClick={handleLogout}
                          >
                            Logout
                          </button>
                        </div>

                        <ul className="px-2 py-1">
                          <li>
                            <Link to="/studentdashboard">
                              <i className="fa fa-tachometer-alt me-2"></i>
                              Dashboard
                            </Link>
                          </li>
                          <li>
                            <Link to="/profile">
                              <i className="fa fa-user-tie me-2"></i>
                              My Profile
                            </Link>
                          </li>
                          {/*<li>
                            <Link to="/enrollments">
                              <i className="fa fa-bookmark me-2"></i>
                              Enrollments
                            </Link>
                          </li>*/}
                          <li>
                            <Link to="/profile/password-change">
                              <i className="fa fa-unlock-alt me-2"></i>
                              Change Password
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </nav>
        </div>
      </div>

}
    </>
  );
}

export default Studentheader;
